export const classes = {
  title:
    'font-bold text-xl text-taupe-3 dark:text-mauve-1 inline flex items-center gap-2',
  subtitle: 'font-normal text-sm text-taupe-2 dark:text-mauve-2 inline',
  closeButtonWrapper: 'place-between',
  closeButtonTitles: 'flex flex-col',
  actionsWrapper: 'flex items-center gap-2',
  closeButton: 'text-taupe-1 dark:text-mauve-3',
  titles: 'pt-3 pb-6',
};
